import Instance from '../../../../utils/Axios';

const GetValidacaoIndividualRH = (id) => async (dispatch) => {
  await Instance()
    .get(`/obras/validacao/recursoshumanos/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_VALIDACAO_INDIVIDUAL_RH', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetValidacaoIndividualRH;
